import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../atoms/Button';
import './ToggleAccessButton.scss';

const ToggleAccessButton = ({
  actionType = 'remove', // 'remove' or 'reactivate'
  onClick,
  disabled = false,
  loading = false,
  text,
  className = '',
  title,
  showText = true,
}) => {
  const getDefaultText = () => {
    switch (actionType) {
      case 'reactivate':
        return 'Reactivate Access';
      case 'remove':
        return 'Remove Access';
      default:
        return '';
    }
  };

  const getButtonProps = () => {
    const baseProps = {
      onClick,
      disabled: disabled || loading,
      className: `ToggleAccessButton ToggleAccessButton--${actionType} ${className}`,
      title: title || getDefaultText(),
    };

    switch (actionType) {
      case 'reactivate':
        return {
          ...baseProps,
          content: '↻',
          variant: 'text',
          color: 'primary',
          className: `${baseProps.className} ${loading ? 'ToggleAccessButton--loading' : ''}`,
        };
      case 'remove':
        return {
          ...baseProps,
          content: 'X',
          variant: 'text',
          color: 'danger',
        };
      default:
        return baseProps;
    }
  };

  const buttonProps = getButtonProps();
  const displayText = text || getDefaultText();

  return (
    <div className="ToggleAccessButton-Container">
      <div className="ToggleAccessButton-Button">
        <Button {...buttonProps} />
      </div>
      {showText && <span className="ToggleAccessButton-Text">{displayText}</span>}
    </div>
  );
};

ToggleAccessButton.propTypes = {
  actionType: PropTypes.oneOf(['remove', 'reactivate']),
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  showText: PropTypes.bool,
};

export default ToggleAccessButton;
